import styled from 'styled-components';

import CustomAssignment from './component';

export const reactSelectStyles = {
  container: (base) => ({
    ...base,
    width: '100%',
    boxShadow: 'none',
  }),
  control: (base) => ({
    ...base,
    borderColor: '#9B9B9B',
    borderRadius: '0px',
    minHeight: 32,
    '&:hover': { borderColor: '#9B9B9B' },
    boxShadow: 'none',
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontWeight: 'bolder',
    fontSize: '100%',
    color: '#3b4f63',
  }),
  // MultiValue margin increased slect height on option selected.
  multiValue: (base) => ({
    ...base,
    margin: '1px 2px',
  }),
  // Dropdown & Clear paddings increased select height by 5 px.
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  // Avoids Stop-stage cells form J cards to overlap the menu.
  menu: (base) => ({
    ...base,
    zIndex: 10,
  }),
};

export default styled(CustomAssignment)`
  padding: 0 1.6rem;

  .placeholder {
    color: var(--grey500);
    font-weight: bold;
    margin-bottom: 0.8rem;
  }

  .form-control {
    margin-bottom: 1.6rem;
  }

  .textarea {
    margin-top: 8px;
    > div {
      width: 100%;
      textarea {
        height: 64px;
      }
    }
  }

  .button {
    background: transparent;
    color: #fff;
    border: 1px solid #fff;
  }
`;
